import { css } from '@emotion/react';
import React from 'react';
import CircleProgressIndicator from './circle_progress_indicator';

export default function LoadingPage () {
  return (
    <div css={css`height: 480px; width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center`}>
      <CircleProgressIndicator size={48}/>
      <p css={css`color: #CCC`}>ページ読み込み中</p>
    </div>
  );
};
